@if (titleContent?.attributes?.showTitle) {
  <article class="page-intro">
    <div class="container">
      <div class="text-align-virt">
        <div class="top-section">
          <H1>{{titleContent.attributes.title}}</H1>
        </div>
        <p>{{titleContent.attributes.content}}</p>
      </div>
    </div>
  </article>
}
@if (editMode()) {
  <button class="button" (click)="onEditTitle()">Edit Title</button>
}
